module.exports = __webpack_public_path__ + "img/timeline.aa03c008.jpg";